import { compose } from '@/utils/story-composer';

function PublicLibraryComponents({ content }) {
	return content;
}

export default PublicLibraryComponents;
compose('public-library-components', PublicLibraryComponents, { children: ['content'] });
